import React from 'react';

import { ModalWindow, Modal } from '../../dweb-common.styles';

import CancellationRescheduleTabView from './cancellation-reschedule-tab-view';
import * as S from './cancellation-reschedule-policy-overlay.styles';

const CancellationReschedulePolicyOverlay = ({
  activePolicySection,
  setShowPoliciesOverlay,
  fareRulesPolicies,
  logCancellationAndRescheduleDetails
}) => {
  return (
    <ModalWindow className="modalVisible">
      <Modal BaggageModal large className="posRel">
        <S.CloseIconRight
          width="2.5rem"
          height="2.5rem"
          fill="#4b4e51"
          onClick={() => setShowPoliciesOverlay('')}
        />
        <S.ModalBodyWrapper>
          <div className="font22 f600">Policies</div>
          <CancellationRescheduleTabView
            activePolicySection={activePolicySection}
            setShowPoliciesOverlay={setShowPoliciesOverlay}
            fareRulesPolicies={fareRulesPolicies}
            logCancellationAndRescheduleDetails={logCancellationAndRescheduleDetails}
          />
        </S.ModalBodyWrapper>
      </Modal>
    </ModalWindow>
  );
};

export default CancellationReschedulePolicyOverlay;
